<div class="report">
  <report-window (clickOnCloseBtn)="clickOnCloseBtnHandler()">
    <div container-header></div>
    <div container-body>
      <div class="report-header-row">
        <h3 class="report-header-dark">EMPTY CONTRACTS REPORT:</h3>
      </div>

      <div class="no-gaps-message" [hidden]="rows.length > 0 || showPreloader">
        <div class="message">
          <b>Great Job!</b>
          <br />
          You Don't have Anymore Empty Contracts.
        </div>
        <success-v-icon class="success-icon"></success-v-icon>
      </div>
      <div>
        <ngx-datatable
          class="bootstrap"
          [rows]="rows"
          [columns]="columns"
          [columnMode]="'force'"
          [headerHeight]="50"
          [footerHeight]="20"
          [loadingIndicator]="showPreloader"
          [rowHeight]="'auto'"
          [count]="180"
          [limit]="10"
          [hidden]="rows.length == 0"
        >
          <ngx-datatable-column
            prop="ContractTenantUniqueId"
            name="Video Id"
          ></ngx-datatable-column>
          <ngx-datatable-column
            prop="ContractTitle"
            name="Title"
          ></ngx-datatable-column>
          <ngx-datatable-column
            prop="ContractMediaId"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [checkboxable]="false"
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <div class="row-header">Edit</div>
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <div>
                <a
                  [routerLink]="['/mam/editMedia/' + value]"
                  [queryParams]="{ tabIndex: 0 }"
                  class="row-header"
                  >Goto Media</a
                >
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </report-window>
</div>
